import type { OrderDto, OrderStatus } from '../api/orderApi';

export const ORDER_STATUS_LABEL: Record<OrderStatus, string> = {
  PENDING: 'Processing',
  PAID: 'Preparing your item',
  AWAITING_SMS: 'Waiting for code',
  COMPLETED: 'Delivered',
  REFUNDED: 'Refunded',
  FAILED: 'Failed',
};

export function isOrderActive(order: Pick<OrderDto, 'status'>): boolean {
  return ['PENDING', 'PAID', 'AWAITING_SMS'].includes(order.status);
}

export function orderProductPath(order: Pick<OrderDto, 'productSlug' | 'productId'>): string {
  return `/product/${encodeURIComponent(order.productSlug || order.productId)}`;
}

export function canReviewOrder(order: Pick<OrderDto, 'status' | 'kind'>): boolean {
  return order.status === 'COMPLETED' && order.kind === 'PURCHASE';
}
